import { convertSafeTimeToDuration } from './formatTimeAndDuration'

export const getSafeDurationAccessor = (date?: string) => {
  const duration = convertSafeTimeToDuration(date)

  return !duration ? '-' : duration.as('milliseconds')
}
